import LargeCard from './LargeCard';
import type { LargeCardProps } from './LargeCard.types';

export type { LargeCardProps };
export { LargeCard };
export default LargeCard;
